/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Individual measurement from a device.
 * @export
 * @interface Measurement
 */
export interface Measurement {
    /**
     * 
     * @type {Date}
     * @memberof Measurement
     */
    timestamp: Date;
    /**
     * 
     * @type {number}
     * @memberof Measurement
     */
    methaneConcentration?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Measurement
     */
    windDirection?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Measurement
     */
    windSpeed?: number | null;
}

/**
 * Check if a given object implements the Measurement interface.
 */
export function instanceOfMeasurement(value: object): value is Measurement {
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function MeasurementFromJSON(json: any): Measurement {
    return MeasurementFromJSONTyped(json, false);
}

export function MeasurementFromJSONTyped(json: any, ignoreDiscriminator: boolean): Measurement {
    if (json == null) {
        return json;
    }
    return {
        
        'timestamp': (new Date(json['timestamp'])),
        'methaneConcentration': json['methane_concentration'] === undefined ? undefined : json['methane_concentration'] === null ? null : json['methane_concentration'],
        'windDirection': json['wind_direction'] === undefined ? undefined : json['wind_direction'] === null ? null : json['wind_direction'],
        'windSpeed': json['wind_speed'] === undefined ? undefined : json['wind_speed'] === null ? null : json['wind_speed'],
    };
}

export function MeasurementToJSON(json: any): Measurement {
    return MeasurementToJSONTyped(json, false);
}

export function MeasurementToJSONTyped(value?: Measurement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timestamp': value['timestamp'].toISOString(),
        'methane_concentration': value['methaneConcentration'],
        'wind_direction': value['windDirection'],
        'wind_speed': value['windSpeed'],
    };
}

